module.exports = __webpack_public_path__ + "img/cloth_g1_item_10.8372beaa.svg";